import React, { useEffect, useState } from 'react'
import TabsHomePage from '../components/tabsHomePage/tabsHomePage'
import { LoadingBar } from 'src/M_Components'
import { ModuleEnumReverse, ModuleActionEnumReverse } from 'src/M_Components/M_Utils/permissions'

export default function HomePage() {
    const [isLoaded, setIsLoaded] = useState(false)
    const [permissions, setPermissions] = useState([])

    useEffect(() => {
        const tempPermissions = JSON.parse(localStorage.getItem('permissions') || '[]')

        const generated = []

        tempPermissions.forEach(p => {
            const moduleName = ModuleEnumReverse[p.Module]
            const actionName = ModuleActionEnumReverse[p.Action]

            if (!moduleName || !actionName) return

            if (actionName === 'Admin') {
                generated.push(
                    {
                        Value: `${moduleName}Create`
                    },
                    {
                        Value: `${moduleName}Update`
                    },
                    {
                        Value: `${moduleName}Delete`
                    },
                    {
                        Value: `${moduleName}Read`
                    },
                    {
                        Value: `${moduleName}List`
                    }
                )
            } else {
                generated.push({
                    Value: `${moduleName}${actionName}`
                })
            }
        })
        
        setPermissions(generated)
        setIsLoaded(false)
    }, [])

    return (
        <>
            {isLoaded ? (<LoadingBar />) : (<TabsHomePage roles={permissions} />)}
        </>
    )
}